import AuthOverlay from "./AuthOverlay";
import {ReactComponent as OrigLogo} from "../../icons/orig-logo.svg";

export default function Loading() {
  return (
    <AuthOverlay>
      <OrigLogo
        className="animate-logoMove fixed left-[37%] w-[60px]"
      />
    </AuthOverlay>

  )
}